import { useEffect, useState } from "react";
import { fetchAlertas, fetchGlobalAlertas } from "../lib/api";
import { useSnapshot } from "../contexts/SnapshotContext";
import { formatEUR } from "../lib/format";
import { RankBadge } from "../components/RankBadge";
import { WarningCircle, ArrowsClockwise, Crown } from "@phosphor-icons/react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function Alertas() {
  const { selected, isGlobal, selectedPais } = useSnapshot();
  const [data, setData] = useState({ items: [], promociones: [] });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const r = isGlobal ? await fetchGlobalAlertas(selectedPais) : await fetchAlertas(selected?.id);
    setData(r);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, [selected?.id, isGlobal]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="p-6 md:p-10 space-y-6" data-testid="alertas-page">
      <header className="flex items-end justify-between">
        <div>
          <p className="text-xs tracking-widest uppercase text-[#736F68] font-display font-semibold">
            Atención requerida
          </p>
          <h1 className="mt-1 text-3xl md:text-4xl font-semibold font-display text-[#2D2A26]">
            Alertas y oportunidades
          </h1>
          <p className="mt-1 text-[#736F68] text-sm">
            {data.items.length} alertas · {data.promociones.length} promociones disponibles
          </p>
        </div>
        <button
          onClick={load}
          className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg border border-[#E5E0D8] hover:bg-[#F2EFEA]"
          data-testid="refresh-alertas-btn"
        >
          <ArrowsClockwise size={14} />
          Refrescar
        </button>
      </header>

      <Tabs defaultValue="riesgo">
        <TabsList className="bg-[#F2EFEA]">
          <TabsTrigger value="riesgo" data-testid="tab-riesgo">
            <WarningCircle size={14} className="mr-1.5" />
            En riesgo ({data.items.length})
          </TabsTrigger>
          <TabsTrigger value="promo" data-testid="tab-promo">
            <Crown size={14} className="mr-1.5" />
            Promociones ({data.promociones.length})
          </TabsTrigger>
        </TabsList>

        <TabsContent value="riesgo" className="mt-4">
          {loading ? (
            <p className="text-[#736F68]">Cargando…</p>
          ) : data.items.length === 0 ? (
            <div className="bg-white border border-[#E5E0D8] rounded-xl p-8 text-center text-[#736F68]">
              Sin alertas. ¡Buen trabajo!
            </div>
          ) : (
            <ul className="space-y-3">
              {data.items.map((a) => (
                <li
                  key={a.id_consultor}
                  className="bg-white border border-[#E5E0D8] rounded-xl p-5 flex items-start gap-4 hover:border-[#D5CFC5] transition-colors"
                  data-testid={`alert-item-${a.id_consultor}`}
                >
                  <div
                    className={`w-1 self-stretch rounded-full ${
                      a.severity === "alta" ? "bg-[#B85C5C]" : "bg-[#E3A569]"
                    }`}
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="font-medium text-[#2D2A26]">{a.nome}</p>
                      <RankBadge rank={a.titulo} />
                    </div>
                    <p className="text-sm text-[#736F68] mt-1">{a.razon}</p>
                    <div className="flex gap-4 mt-2 text-xs text-[#736F68]">
                      <span className="font-mono">Personal: {formatEUR(a.vendas_pessoais)}</span>
                      <span className="font-mono">Equipo: {formatEUR(a.vendas_equipa)}</span>
                      {a.lider_subequipa && <span>Líder: {a.lider_subequipa}</span>}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </TabsContent>

        <TabsContent value="promo" className="mt-4">
          {data.promociones.length === 0 ? (
            <div className="bg-white border border-[#E5E0D8] rounded-xl p-8 text-center text-[#736F68]">
              Ninguna consultora califica este mes para subir de estatus.
            </div>
          ) : (
            <ul className="space-y-3">
              {data.promociones.map((p) => (
                <li
                  key={p.id_consultor}
                  className="bg-[#8A9A86]/8 border border-[#8A9A86]/30 rounded-xl p-5 flex items-center justify-between"
                  style={{ backgroundColor: "rgba(138, 154, 134, 0.07)" }}
                  data-testid={`promo-item-${p.id_consultor}`}
                >
                  <div>
                    <p className="font-medium text-[#2D2A26]">{p.nome}</p>
                    <p className="text-xs text-[#736F68] mt-0.5">
                      Actual: {p.actual} · Cumple para subir
                    </p>
                  </div>
                  <RankBadge rank={p.califica_para} />
                </li>
              ))}
            </ul>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}